/**
 * Подписи AI-моделей для интерфейса (QA-15 от 15.09.2026): вместо технической строки
 * («codex-cli», «gpt-5.6-terra») пользователь видит «провайдер · модель» — «Claude · Opus»,
 * «Codex», «OpenAI · gpt-5.6-terra». Один словарь для чата стилиста и журнала распознавания.
 */

/** Человекочитаемые имена провайдеров (FR-7): значение enum бэкенда → подпись. */
const PROVIDER_LABELS: Record<string, string> = {
    CLAUDE_CLI: 'Claude',
    CODEX_CLI: 'Codex',
    OPENAI_API: 'OpenAI',
};

/** Короткие имена моделей Claude-подписки (FR-7): opus → «Opus» и т.п. */
const CLAUDE_MODEL_LABELS: Record<string, string> = {opus: 'Opus', sonnet: 'Sonnet', haiku: 'Haiku'};

/** Дефолт-репорты CLI-гейтвеев: модель неизвестна — показываем только провайдера. */
const CLI_DEFAULT_MODELS = ['claude-cli', 'codex-cli'];

/** Фолбэк-эвристика провайдера для старых сообщений без поля provider (FR-8). */
const inferProviderLabel = (model: string): string | null => {
    const m = model.toLowerCase();
    if (/(opus|sonnet|haiku|claude)/.test(m)) return PROVIDER_LABELS.CLAUDE_CLI;
    if (m.includes('codex')) return PROVIDER_LABELS.CODEX_CLI;
    if (m.startsWith('gpt-')) return PROVIDER_LABELS.OPENAI_API;
    return null;
};

/** Короткое имя модели для подписи; null — модель не показываем (дефолт-репорт CLI). */
const modelLabelOf = (model: string): string | null => {
    const m = model.toLowerCase();
    if (CLI_DEFAULT_MODELS.includes(m)) return null;
    for (const key of Object.keys(CLAUDE_MODEL_LABELS)) {
        if (m.includes(key)) return CLAUDE_MODEL_LABELS[key];
    }
    return model;
};

/**
 * Подпись фактической модели ответа в формате «провайдер · модель» (FR-7/FR-8):
 * «Claude · Opus», «OpenAI · gpt-5.6-terra», «Codex». Провайдер — с бэкенда; для
 * старых сообщений (provider=null) — эвристика по имени модели, иначе сырая строка.
 */
export const formatModelCaption = (model?: string | null, provider?: string | null): string | null => {
    if (!model) return null;
    const providerLabel = (provider && PROVIDER_LABELS[provider]) || inferProviderLabel(model);
    if (!providerLabel) return model;
    const modelLabel = modelLabelOf(model);
    return modelLabel ? `${providerLabel} · ${modelLabel}` : providerLabel;
};
